import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { CreateSharePlanDto } from '../../types/pool-plans.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useCreate = () => {
  const { mutate: create, isPending } = useAppMutation([QueryKey.CREATE_SHARE_PLAN], {
    mutationFn: ({ companyId, data }: { companyId: string; data: CreateSharePlanDto }) =>
      ApiService.post(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'share-plans'] },
        { body: data },
      ),
  });
  return { create, isPending };
};
